import React from 'react'
import EntityToggle from './EntityToggle'
import { INBOUND, OUTBOUND } from '../useManageEntities'
import * as entityHeading from '../../../Constants/Constants'
import Style from '../manageEntities.module.css'

const EntityRow = ({ entity, isSaving, onToggle }) => (
    <tr className={isSaving ? Style.rowSaving : undefined}>
        <td className={Style.nameCell}>
            <span className={Style.entityName}>{entity.displayName}</span>
        </td>
        <td>
            <EntityToggle
                label={entityHeading.entityHeading.targetToSource}
                isActive={entity.isInboundActive}
                isEditable={entity.isInboundEditable}
                isSaving={isSaving}
                onChange={(isActive) => onToggle(entity, INBOUND, isActive)}
            />
        </td>
        <td>
            <EntityToggle
                label={entityHeading.entityHeading.sourceToTarget}
                isActive={entity.isOutboundActive}
                isEditable={entity.isOutboundEditable}
                isSaving={isSaving}
                onChange={(isActive) => onToggle(entity, OUTBOUND, isActive)}
            />
        </td>
    </tr>
)

export default EntityRow
